import bidello, { component } from "./bidello"
import gsap, { Power4 } from 'gsap'

import assets from './webgl/assets'

import { qs } from './utils'

class Loader extends component() {
  constructor() {
    super()
    this.loader = qs('[data-loader]')
    this.container = qs('.c-loader__container', this.loader)
    this.bg = qs('.c-loader__bg', this.loader)
    this.progress = qs('.c-loader__progress', this.loader)
    this.snail = qs('.c-loader__snail', this.loader)
    this.numbObj = { value: 0 }
    this.numbTag = qs('p', this.loader)
  }

  onEnterSite() {
    gsap.to(this.container, {
      autoAlpha: 1,
      duration: 1.2,
      delay: 1.2,
      ease: Power4.easeOut,
      onComplete: () => {
        // assets.load()
        assets.loadGltfFirst()
      }
    })
  }

  onLoadProgress(load) {
    const { width } = qs('[data-loader-container]').getBoundingClientRect()
    const { progress } = load

    if (progress === 50) return

    gsap.to('[data-loader-progress]', {
      scaleX: progress / 100
    })

    gsap.to('[data-loader-snail]', {
      x: width * (progress / 100)
    })

    gsap.to(this.numbObj, {
      value: progress,
      onUpdate: () => {
        this.numbTag.innerText = `${Math.floor(this.numbObj.value)}%`
      }
    })
  }

  onLoadEnd() {
    const tl = gsap.timeline({
      delay: 0.8
    })

    tl
      .add('start')
      .to([this.progress, this.bg], {
        duration: 1.4,
        scaleX: 0,
        ease: Power4.easeOut,
        transformOrigin: 'right center',
        stagger: 0.1
      })
      .to(this.snail, {
        duration: 1.4,
        autoAlpha: 0,
        xPercent: 40,
        ease: Power4.easeOut
      }, '-=0.8')
      .to(this.loader, {
        duration: 1.2,
        autoAlpha: 0,
        display: 'none',
        ease: Power4.easeOut
      })
      .add(() => {
        bidello.trigger({ name: 'loaderEnd' })
      }, '-=1.2')
  }
}

export default new Loader()